import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBadge,{attrs:{"color":"red darken-2","content":_vm.getUnreadNotificationsCount,"value":_vm.getUnreadNotificationsCount > 0,"bottom":"","overlap":"","offset-x":"10"}},[_c('w-icon',{attrs:{"color":"white"}},[_vm._v(" $wNotification ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }